import { useQuery } from "@tanstack/react-query";

import { ListCompaniesQueryFilters, UseListCompaniesQueryOptions } from "./types";
import { getCompaniesService } from "./service";

export const listCompaniesQueryKey = ["company_admin"];

export function useListCompaniesQuery(
  filters?: ListCompaniesQueryFilters,
  options?: UseListCompaniesQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listCompaniesQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getCompaniesService(filters),
    ...options,
  });
}
